interface PaginationProps {
  currentPage: number;
  onPrevious: () => void;
  onNext: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
}

export const Pagination = ({
  currentPage,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
}: PaginationProps) => (
  <div className="flex items-center justify-start gap-2">
    <button
      onClick={onPrevious}
      disabled={!hasPrevious}
      className="px-5 py-1.5 bg-dark-10 text-dark-70 hover:text-dark-text text-sm rounded-[5px] border border-dark-20 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      Previous
    </button>
    <span className="text-dark-text text-sm py-1 px-2">{currentPage}</span>
    <button
      onClick={onNext}
      disabled={!hasNext}
      className="px-5 py-1.5 bg-dark-10 text-dark-text hover:text-dark-white text-sm rounded-[5px] border border-dark-20 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      Next
    </button>
  </div>
);
